import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import Api from '../../../helpers/api';
import { keyByProperty } from '../../../helpers/core';
import { t } from '../../../i18n';
import { PRE_ENROLMENT_INACTIVITY_FIELD } from './automationConfig.const';

const api = new Api('organizations_countries');
const formDataApi = new Api('organizations_countries/form_data');

function* loadData() {
  try {
    const result = yield call(sendRequest, api.load, {}, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      yield put(actions.loadDataSuccess({ data: result.data.success.data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormData() {
  try {
    const result = yield call(sendRequest, formDataApi.load, {}, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      yield put(actions.loadFormDataSuccess({ data: result.data.success.data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export function* update({ payload }) {
  try {
    const { editForm, paymentSettingsId } = payload;
    const propsArray = Object.values(editForm);
    const organizations_country = keyByProperty(propsArray, 'name', prop => prop.value);
    const {
      auto_close_setting,
      billing_info_completion_credit,
      shift_manager_info_credit,
      enabled_payment_methods,
      default_payment_method,
      min_allowed_time_to_book,
      priority_pricings,
      contesting_timeframe_duration,
      grace_period,
      dayforce_clock_facial_pre_enrolment_hard_limit_minutes,
      dayforce_clock_facial_pre_enrolment_inactivity_days,
    } = organizations_country;
    const { id, start_time, stop_time, variations } = auto_close_setting;

    const data = {
      organizations_country: {
        auto_close_setting_attributes: {
          id,
          start_time,
          stop_time,
          variations_attributes: variations,
        },
        billing_info_completion_credit: parseFloat(billing_info_completion_credit),
        shift_manager_info_credit: parseFloat(shift_manager_info_credit),
        min_allowed_time_to_book,
        priority_pricings_attributes: priority_pricings,
        contesting_timeframe_duration,
        ...(dayforce_clock_facial_pre_enrolment_hard_limit_minutes != null && {
          dayforce_clock_facial_pre_enrolment_hard_limit_minutes: parseInt(
            dayforce_clock_facial_pre_enrolment_hard_limit_minutes,
            10,
          ),
        }),
        ...(PRE_ENROLMENT_INACTIVITY_FIELD in organizations_country && {
          dayforce_clock_facial_pre_enrolment_inactivity_days:
            dayforce_clock_facial_pre_enrolment_inactivity_days === '' ||
            dayforce_clock_facial_pre_enrolment_inactivity_days == null
              ? null
              : Number(dayforce_clock_facial_pre_enrolment_inactivity_days),
        }),
        grace_period: {
          before_clock_in: grace_period.before_clock_in,
        },
        payment_setting_attributes: {
          id: paymentSettingsId,
          enabled_payment_methods,
          default_payment_method,
        },
      },
    };

    const result = yield call(sendRequest, api.updateItem, { data }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      yield put(actions.updateSuccess({ organizations_country }));
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.updated_successfully', {
            item: t('dash.admin.automationConfig.automation_config_title'),
          }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.UPDATE, update)]);
  yield all([takeEvery(actions.LOAD, loadData), takeEvery(actions.LOAD_FORM_DATA_REQUEST, loadFormData)]);
}
